const initState = {
  teamrosterData: [],
};

const teamRosterReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_TEAM_ROSTER":
      return {
        ...state,
        teamrosterData: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default teamRosterReducer;
